// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Уведомление клиента о переходе",
  "1d484fee4a": "Финансовый отдел, отдел продаж, проектный менеджмент, бизнес-данные, продуктовый отдел, отдел эксплуатации, управление разработкой, планирование версий, отдел поддержки, административный отдел, отдел закупок, управление постпродажным обслуживанием",
  "a2c88dfb79": "Создайте свою первую команду",
  "3cfdcc6086": "Финансовый отдел, отдел продаж, проектный менеджмент/305, управление персоналом/306, отдел эксплуатации, управление разработкой, планирование версий, поддержка клиентов/403, отдел закупок, управление постпродажным обслуживанием",
  "ac45ec2c05": "Ошибка проверки учетной записи",
  "9aef9b8ccd": "Текущая учетная запись неработоспособна, попробуйте снова войти в систему",
  "728dd00f22": "Проблемы с проверкой номера телефона, попробуйте войти с использованием SMS-кода",
  "30dbecd916": "Ваши данные содержат чувствительные слова, измените их и попробуйте снова",
  "12ed508d8a": "Слишком частые операции, попробуйте позже",
  "952d4a7595": "Ошибка состояния текущей учетной записи, попробуйте снова войти в систему",
  "e64bfdeaa4": "Ошибка проверки входа, попробуйте снова получить SMS-код",
  "79008a65f1": "Этот номер телефона связан с несколькими компаниями, войдите в компанию или замените номер",
  "bf242eff42": "Название компании уже существует",
  "4f0cdb8374": "Пожалуйста, введите полный номер телефона. Если вы используете международный номер, измените его на внутренний номер (86+)",
  "46e79ffeff": "Ошибка создания компании, обратитесь в службу поддержки",
  "f3e18f0341": "Ошибка проверки параметров",
  "503fd1718d": "Не удалось отправить SMS-код",
  "24b3129f19": "Слишком частая отправка сообщений, попробуйте позже",
  "1cde3e8245": "Ошибка кода, введите снова",
  "4212ecc031": "Много ошибок в проверке, временно ограничиваем доступ, попробуйте позже",
  "735da9c347": "Ошибка проверки дублирования имени компании, обратитесь в службу поддержки",
  "8731da9615": "Ошибка проверки подлинности имени компании, обратитесь в службу поддержки",
  "62e89b3f16": "Согласитесь с условиями обслуживания",
  "c9b79027e5": "Отправить код",
  "84c1447b9d": "Успешно скопировано",
  "fba4b0abd0": "Запись хоста",
  "37f5a7cd41": "Значение TXT",
  "78b12427c9": "Подтверждение...",
  "59d089837c": "Мы не можем подтвердить ваш домен, возможно, потребуется подождать обновления от вашего провайдера. Если проблема не решится, попробуйте повторную верификацию или замените домен.",
  "4a5b7383d1": "Проверка домена",
  "f24a492e40": "записей проверки, вы можете закрыть эту страницу и вернуться позже.",
  "c697ca5f1a": "Добро пожаловать в корпоративную версию",
  "ebb01b1740": "далее",
  "30109bf753": "Есть ли у вашей компании доменное имя?",
  "2b3e485b47": "У меня есть корпоративный домен",
  "1a7f5eae44": "У меня нет корпоративного домена",
  "bde15d6d84": "Вам необходимо иметь доменное имя (например, example.com), чтобы создать учетную запись для вашей компании",
  "07ffb22c90": "Извините, вам необходимо иметь доменное имя, чтобы создать учетную запись для вашей компании",
  "de23836563": "Введите доменное имя для создания корпоративной учетной записи",
  "287c07944a": "Проверьте ваш домен",
  "3ea2d528d5": "Выполните следующие шаги, чтобы подтвердить, что вы являетесь владельцем <b>{domain}</b> и запретить другим использовать это доменное имя для регистрации корпоративной учетной записи.",
  "082b18ce56": "a. Откройте веб-сайт вашего хостинг-провайдера доменных имен в <b>новой вкладке</b>, затем <b>войдите</b> в свою учетную запись;",
  "4f7e0841a9": "b. На сайте провайдера услуг доменного хостинга перейдите в раздел <b>DNS-записей</b>. Имя раздела DNS-записей на вашем сайте провайдера услуг доменного хостинга может отличаться, например, отображаться как <b>Управление DNS, Управление серверами имен, Панель управления или Расширенные настройки.</b>",
  "6365ad6e3a": "Далее, <b>вернитесь сюда</b> и нажмите «Далее», чтобы добавить проверочную запись.",
  "8528892080": "Добавить проверочную запись",
  "7a225304f8": "a. На странице DNS прокрутите до раздела <b>TXT</b>, затем нажмите соответствующую кнопку для добавления записи.",
  "b3cb7d947c": "b. <b>Скопируйте и вставьте</b> все значения ниже в <b>форму TXT</b> на сайте вашего провайдера доменных имен.",
  "47213583bf": "c. <b>Сохраните</b> записи на сайте регистратора доменных имен, <br> затем <b>вернитесь сюда</b> и нажмите ниже «Подтвердить домен»",
  "21486a57cf": "Внимание: в поле Название/Хост/Псевдоним можно ввести «@» или оставить его пустым. Сервис доменных имен может также потребовать ввода вашего домена (вашдомен.com). Возможно, вы сможете решить, как заполнить это поле, основываясь на других DNS записях. В поле «Время жизни» (TTL) введите «86400» или оставьте значение по умолчанию.",
  "f1b8edab9c": "Изменить домен",
  "7c6fc663a8": "Подтвердить домен",
  "b6aee9dc0d": "Проверка домена успешна",
  "dd4cc429ea": "Вы подтверждены как владелец",
  "450f5c9230": "и запрещаете любому другому лицу использовать этот домен для регистрации корпоративного аккаунта.",
  "71cbcba755": "Нажмите «Далее», чтобы завершить создание корпоративного аккаунта.",
  "f4084f4870": "Пожалуйста, установите ваш аккаунт для входа",
  "fe3138baec": "Завершить создание",
  "0315cddedb": "Предприятие успешно создано",
  "91454a7f34": "Теперь войдите в панель управления, чтобы создать учетные записи для сотрудников вашего предприятия",
  "366304cde7": "1. Вы автоматически выйдете из текущего аккаунта WPS",
  "8a9f2a8422": "2. Вы должны войти в панель управления с помощью корпоративного аккаунта {account}@{domain}",
  "43e265e998": "Перейти в панель управления",
  "9240efaaf0": "Сообщение было отправлено",
  "e424bb9a6d": "Введите",
  "d44d581706": "Название предприятия",
  "aa8679f406": ", от 4 до 30 символов",
  "581bdb1f98": "Не может содержать специальные символы \\/:*?\"<>|{}",
  "c13cabb67a": "адрес электронной почты:",
  "2b9b429e46": "Ваш email",
  "5ed834a7df": "Пожалуйста, введите ваш email",
  "acfd1f02ed": "Пожалуйста, введите правильный email",
  "31c7c92cca": ", не более 80 символов",
  "3f27cf84b3": "Пожалуйста, введите код подтверждения",
  "a0ae1f3ec4": "Код подтверждения неправильный",
  "e5589c5e74": "Ваше имя",
  "69d7bd63f6": ", только китайские иероглифы, буквы или цифры",
  "91f008d258": ", не более 8 символов",
  "6ea6c9b39b": "Телефон",
  "161042c5b7": "Пожалуйста, введите номер телефона",
  "e6b8eab1cd": "Пожалуйста, введите номер телефона, 11 цифр",
  "3fd5fbb3cc": "Пожалуйста, введите ваш домен",
  "cb5346ba8e": "Пожалуйста, введите правильное доменное имя компании длиной от 4 до 30 символов",
  "27928eb7a4": "Учётная запись",
  "8e19bd444d": "Пожалуйста, введите имя учётной записи для входа",
  "7bbbf479dc": "4-20 символов, только цифры, буквы или подчёркивания",
  "3d84cae479": "Пожалуйста, введите учетную запись, соответствующую требованиям: первый символ должен быть буквой или цифрой",
  "c0d5ece1a7": "Пароль",
  "f444036fa8": "Введите пароль",
  "b03218d72b": "Пароль должен состоять из 12-16 символов, включая заглавные и строчные буквы, числа или их три комбинации",
  "b4ab05df50": "* Ваша организация уже использует ваш домен для корпоративной учетной записи, пожалуйста, свяжитесь с клиентской службой (400-677-5005), чтобы подтвердить, что вы являетесь владельцем этого домена",
  "c58876008f": "Копирование не удалось, пожалуйста, попробуйте еще раз",
  "86f73420de": "Ссылка для приглашения",
  "a58861962c": "Извините, ваш текущий браузер не поддерживает скачивание этого QR-кода",
  "228db07f78": "Финансовый отдел, Отдел продаж, Проектное управление, Бизнес-данные, Продуктовый отдел, Операционный отдел, Управление исследованиями и разработками, Планирование версии, Отдел обслуживания, Административный отдел, Отдел закупок, Управление после продаж",
  "93896d7e98": "После создания команды начните сотрудничество с коллегами",
  "e8f66fb75c": "Финансовый отдел, Отдел продаж, Управление проектами/305, HR и Административный/306, Операционный отдел, Управление исследованиями и разработками, Планирование версии, Управление обслуживанием клиентов/403, Отдел закупок, Управление после продаж",
  "831b73da9b": "Имя не может содержать нелегальные символы и специальные знаки /\\;:*?\"<>|%&",
  "51ab33b3ee": "Неверный параметр",
  "a297f9e951": "Название компании дублируется",
  "04d60ed5f5": "Нельзя использовать запрещенные слова",
  "2ff7bef083": "Ошибка формата домена",
  "41e1ba2165": "Не удалось проверить информацию TXT домена",
  "50f348caa9": "Дублирование аккаунта",
  "9d4c950d65": "Это имя уже зарегистрировано",
  "38cf19ed95": "Данное название организации уже существует",
  "4b426e7c9c": "Имя организации",
  "298f880e18": "Уже существует, рекомендуется добавить больше информации:",
  "1e67dd20b3": "Восстановить название организации",
  "517107cb04": "Использовать другое название",
  "5667081882": "Создать с этим именем",
  "e306a979a6": "Быстро ввести:",
  "f583db96e0": "* Если название организации занято, вы можете",
  "9767148e34": "Введите название компании или организации, от 4 до 100 символов",
  "e0e0ec159f": "Название организации",
  "5b13d254c0": "Данное название компании уже существует",
  "92027671ec": "Имя компании",
  "36d482a7fb": "Восстановить название компании",
  "79058a7577": "* Если название компании занято, вы можете",
  "c96dd48dba": "Название компании",
  "842efad336": "* Если вы сотрудник компании, пожалуйста",
  "860f9bd77b": "Служба клиентской поддержки",
  "5a7ed18daf": "Присоединиться к компании",
  "ab470e9ace": "Оставьте контактную информацию",
  "0a7e0e48a7": "Название компании, к которой хотите присоединиться:",
  "a8dc318dcc": "Пожалуйста, проверьте введенную вами контактную информацию, вскоре к вам обратится служба поддержки платформы",
  "6ea1f4d7f5": "Отправить данные",
  "d439e39f43": "Ваши данные получены",
  "884653426b": "Служба поддержки свяжется с вами в течение 24 часов, пожалуйста, примите звонок!",
  "2361cb14bf": "Отсканируйте QR-код с WeChat, чтобы добавить онлайн-службу поддержки и узнать прогресс",
  "50f45d0031": "Сохранение не удалось",
  "fc856d0fd2": "Суперадминистратор",
  "e16c0676d2": "Администраторы",
  "b1d2ddd126": "Обычный участник",
  "9d322cc08d": "Название учреждения не должно содержать специальных символов \\/:*?\"<>|{}",
  "b583ba7363": "Название компании не может содержать специальные символы \\/:*?\"<>|{}",
  "1d118a9bad": "Название учреждения должно содержать минимум 4 символа, пожалуйста, введите название длиной от 4 до 100 символов",
  "441b45b1f5": "Название компании должно содержать минимум 4 символа, пожалуйста, введите название длиной от 4 до 100 символов",
  "97457cb1f0": "Название учреждения превышает 100 символов, пожалуйста, введите название длиной от 4 до 100 символов",
  "8ce00d3b92": "Название компании превышает 100 символов, пожалуйста, введите название длиной от 4 до 100 символов",
  "a72778d3de": "Имя должно содержать минимум 2 символа, пожалуйста, введите имя длиной от 2 до 10 символов",
  "79c17db5de": "Имя превышает 10 символов, пожалуйста, введите имя длиной от 2 до 10 символов",
  "482a118202": "Имя может содержать только китайские иероглифы, цифры, буквы и ·",
  "9a9be18941": "Пожалуйста, отметьте",
  "e6b7c4aa66": "Соглашение об онлайн-обслуживании",
  "595023d905": "Создать учреждение",
  "ba8c2df551": "Скрыть стандартные местоположения",
  "d284384975": "Онлайн-сервисное соглашение",
  "5c266d5a84": "Политика конфиденциальности",
  "fcb92dbcf6": "Соглашение об облачных офисных услугах",
  "2ae7a8a3f7": "Спасибо, что выбрали облачные офисные услуги WPS 365. Ниже приводится информация о юридическом соглашении о регистрации, подписке и использовании данной услуги, заключенном между вами и/или вашей организацией и компанией Kingsoft.",
  "d30a6983bd": "Пожалуйста, прочтите {0} | {1} | {2}, нажав «Согласен», вы соглашаетесь с содержанием соглашения и принимаете наши услуги.",
  "263e306ede": "Я прочитал и согласен с {0} | {1} | {2}",
  "440129c0f1": "Пожалуйста, введите {0}",
  "8ab916983d": "Название компании",
  "b01d68543b": "Ваше имя",
  "684b30d4e9": "Ваш номер телефона",
  "a48427e8e2": "Для создания рабочей платформы для вашей компании",
  "3a81b0f1fc": "Чтобы коллеги могли найти вас в системе и сотрудничать с вами",
  "52bc539b6e": "Подтвердить создание",
  "b2fe245e19": "Создание предприятия/команды: Совместное использование и совместная работа с файлами",
  "893282d3f7": "Пожалуйста, дополните информацию о компании:",
  "cc997bf6aa": "Подтвердить",
  "50fdde51ac": "{0}, от {1} до {2} символов",
  "a19cc5ec18": "{0}, не может содержать специальные символы \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, вводите только китайские символы, буквы и цифры",
  "f4080b1431": "{0}, не более {1} символов",
  "88e59b2d58": "{0}, 11 цифр",
  "91d6d4e105": "Введите код подтверждения",
  "bec71bde96": "Неверный код подтверждения",
  "e20ff8ee19": "{0} обязательное поле",
  "8dc09d10d7": "dwId не найден",
  "a03766ce6c": "Учебное заведение",
  "03542addfe": "предприятие",
  "adb8a815d1": "Связывание номера телефона {0} достигло предела",
  "97a6b66f1d": "Текущий номер телефона уже связан с {0}",
  "665e465487": "Не удается создать {0}, текущий номер телефона «<strong>{1}</strong>» уже привязан к максимальному количеству {0} (можно привязать не более 5 {2}). Вы можете перейти к ниже привязанным {3}:",
  "a85b1367ca": "Текущий номер телефона «{0}» уже связан с {1}, вы можете выбрать существующий {2} для входа или создать новый {3}:",
  "bf992ce17b": "Создать с другим номером телефона {0}",
  "395ea04444": "Создать новый {0}",
  "4ce3bb86b3": "Количество членств {0} превышено",
  "df88c4b7a5": "Текущий номер телефона «{0}» связан с {1} в максимально допустимом количестве",
  "78f7dd59ca": "Текущий номер телефона «{0}» связан с следующим {1}, вы можете переключиться на использование",
  "8db491a3f8": "Продолжить создание нового {0}",
  "83f6d9e1e4": "Попробовать снова",
  "1dc5f11612": "или",
  "217d76f53e": "Обратная связь",
  "b69a6ea62a": "Удерживайте левую кнопку мыши и обнаружьте две стороны щита",
  "3a31f64800": "Поздравляем с успешным обнаружением щита<br/>Продолжайте на следующем этапе",
  "6a81fcee96": "Загрузка",
  "e97877a65d": "Ой, щит пропал<br/>пожалуйста",
  "8d85456145": "Я ждал слишком долго<br/>пожалуйста",
  "77ad847b95": "Очень плохое соединение с сетью<br/>пожалуйста",
  "dbd1ae3a34": "Вы слишком быстро ощупали<br/>пожалуйста",
  "bd8e05cd53": "Нажмите кнопку, чтобы начать интеллектуальную проверку",
  "63d2a8a722": "Проверка прошла успешно",
  "73141928ad": "Проверка не удалась, пожалуйста, нажмите кнопку для обновления",
  "04856c5c8a": "Идет интеллектуальное обнаружение",
  "52cd9bd26d": "Ваше действие не авторизовано",
  "fd157e8ea8": "Руководство по созданию",
  "c6225c5b2b": "Добро пожаловать в корпоративную версию",
  "e33423fb1e": "Создание успешно",
  "7b0c035999": "Успешное создание корпоративной страницы Kingsoft Docs",
  "85db8faae0": "Инструкция по использованию корпоративной версии",
  "20591b9b44": "Восстановить название предприятия",
  "b023d76dc2": "Руководство по загрузке участника",
  "e2f454e095": "Предприятие {0}",
  "df466f942b": "Филиал",
  "26a7b797c4": "Филиал",
  "5fc82b360b": "Универсальная платформа для офисных услуг, существенно повышает вашу эффективность",
  "f2e736d52e": "Добро пожаловать в корпоративную версию",
  "becc41a35b": "Название предприятия",
  "74685cdc58": "Введите название компании или организации, от 4 до 100 символов.",
  "07b55b1907": "Масштаб предприятия",
  "77b2f763ad": "Пожалуйста, выберите масштаб вашего предприятия",
  "49d2509109": "Менее 5 человек",
  "8db2c9b74a": "6-20 человек",
  "a9fb0cf14a": "21-50 человек",
  "0fed41f8d3": "51-100 человек",
  "fb33f25a04": "101-200 человек",
  "3e3ff0f52e": "201-500 человек",
  "cd8b51f634": "501-2000 человек",
  "0662fa6eec": "Более 2000 человек",
  "69334dba1a": "Потребности предприятия",
  "79994e749c": "(Мы рекомендуем лучшие отраслевые решения для предприятия)",
  "840a017f38": "Пожалуйста, выберите проблему, которую хотите решить",
  "f045b05c73": "Введите ваши потребности в создании предприятия",
  "d8efb0b36d": "Другие",
  "adcb8fbb0c": "Часто используемый номер телефона",
  "eb1c73e2ca": "Пожалуйста, введите ваш часто используемый 11-значный номер телефона",
  "7f276e7dfa": "Создать бесплатно",
  "c391b3eec1": "Ошибка отправки SMS",
  "54f4cb8fa7": "SMS отправлено",
  "231eb1fa1e": "Корпоративный пользователь {0}",
  "272b0f9d32": "Корпоративный пользователь",
  "b209a67331": "Ошибка создания предприятия, обновите страницу.",
  "acb08d0cc9": "Третий шаг создания предприятия",
  "83db361f51": "После создания сработает логика перенаправления",
  "1e930326e3": "handleStep переход на следующий шаг",
  "184df5c725": "Ошибка при saveForm",
  "736eab3023": "Проверка отправки",
  "2db62dc13c": "Ошибка проверки",
  "54fb0afaea": "Проверка успешна",
  "d39cff3fcf": "Пропустите крайнюю сохраняемую ситуацию, только чтобы обнаружить, что требуется проверочный код",
  "305b777ae5": "Ошибка проверки названия включает всплывающее окно \"Название предприятия занято\" и хранение названия",
  "e57b6686b2": "Проверьте, была ли сертифицирована сертификационная единица, откройте всплывающее окно с подсказкой о защите сертификации и сохраните соответствующую информацию о сертификации",
  "f7c86f496d": "Создание имени дубликата || код подтверждения истек. Если имеется несовпадение, выполнение блокируется",
  "cb37db4fd4": "Отправка данных не удалась",
  "243a569fc4": "Это название уже зарегистрировано, пожалуйста, используйте другое",
  "196851a3d9": "Корпоративный пользователь {0}",
  "0c3a3595ff": "Корпоративный пользователь",
  "a33b41e0f2": "Ошибка создания предприятия, обновите страницу.",
  "fcce6a7156": "Создание успешно",
  "5ec6da58a6": "Оповестить клиент",
  "259c9dfa4e": "Логика профессиональной версии",
  "864156930f": "Логика VBA",
  "7824efd172": "Мобильная версия Docs",
  "52b6cfaaaf": "Клиент WPS",
  "c7c51beea9": "Версия для образования",
  "8d054d4986": "Версия по умолчанию",
  "b597e18fb1": "isWps365PcClient и есть openurl",
  "b0c13de2a0": "isWps365PcClient или не клиент, есть openurl",
  "7d0f2ce18c": "isWps365PcClient или не клиент, есть успешный openurl вызов",
  "e2c5a07df6": "Не клиент, не openurl",
  "29e0414d1f": "Не клиент, не openurl, обратный вызов",
  "60861f7d2a": "Автоматическое переключение, предоставленное бизнесу для самостоятельного переключения",
  "7c83140d90": "Создание в гостевом режиме, не требуется использование SDK для переключения учетной записи (SDK не поддерживает гостя), код успешно переключился через интерфейс",
  "3379b09e59": "Есть openurl и переход с использованием href",
  "586ff04c22": "Отдельный переход",
  "b6c91f218b": "UseSuccessSkip не удалось",
  "47d2f3ba66": "Другие",
  "57551f86ce": "По различным методам определяются переходы в зависимости от utm_source",
  "64fe3758e2": "Ваши действия не авторизованы",
  "4da3e1262f": "Создание выполнено успешно, начните корпоративное офисное путешествие",
  "c38dfb8c6c": "Создайте свою первую команду",
  "38dddb483b": "Войти в компанию",
  "614d9c91eb": "Пригласите участников присоединиться",
  "97f1eca0aa": "Войти в компанию",
  "13a4939e90": "Присоединиться к приглашению в компанию",
  "a319e4ae0a": "Пригласите коллег присоединиться",
  "12e4da6bba": "Пригласите коллег прямо сейчас",
  "bd885380f6": "Не удалось получить ссылку для приглашения",
  "5e626c4063": "СМС отправлено",
  "3dc09e7cfd": "Вы достигли лимита на количество заявок на восстановление названия компании",
  "48318f41f9": "Пригласите участников присоединиться",
  "45441baac4": "Пригласи присоединиться к {0} для совместной работы",
  "e5847fbd67": "Скопируйте ссылку, чтобы пригласить участников",
  "23101dd40a": "Настраиваем решение для вас",
  "71bb7e54a8": "Управление проектами",
  "aff37c79cc": "Испытайте выбранное решение",
  "a97b174258": "Пригласите ещё <color: red>2</> коллеги и получите следующие корпоративные привилегии бесплатно",
  "253855849f": "Поделитесь ссылкой приглашения в рабочем чате, чтобы пригласить коллег",
  "57b0a2a63f": "Скопируйте ссылку, чтобы пригласить коллег",
  "71c0a37ee1": "Войти в компанию",
  "f848c60e0e": "Пригласите ещё <color:red>2</> коллеги и получите следующие корпоративные привилегии бесплатно",
  "664e32b4fe": "Страница приглашения Войти в компанию",
  "872f14403a": "Пригласите коллег присоединиться",
  "1880e7deb9": "Пригласите коллег прямо сейчас",
  "cc2a9aaf82": "Создание выполнено успешно",
  "02a13e2583": "Пригласите ещё <color: red>2</> коллеги и получите следующие корпоративные привилегии бесплатно",
  "5d3593cdce": "Не удалось получить информацию о команде",
  "c025113ea1": "Не удалось получить ссылку для приглашения",
  "b83bc1e485": "Ссылка приглашения",
  "0996ced9f6": "Извините, ваш текущий браузер не поддерживает загрузку этого QR-кода",
  "1e88451e31": "Ссылка приглашения успешно скопирована",
  "bb969cabcd": "Ошибка копирования, пожалуйста, попробуйте снова",
  "15e1f79c7a": "Запрос на присоединение к компании",
  "59c22b4ef8": "Получена ссылка для приглашения",
  "0f0b392e60": "Создайте свою первую команду",
  "0437d07c43": "Название компании",
  "41800c7bf1": "Пожалуйста, введите имя создателя",
  "1ec5999511": "Имя создателя не должно превышать 8 символов",
  "02da35b4e4": "Имя создателя может содержать только китайские иероглифы, буквы и цифры",
  "184e9f6616": "Пожалуйста, введите контактный телефон",
  "9b587898ba": "Пожалуйста, введите контактный телефон в правильном формате",
  "e68c164a02": "Пожалуйста, введите ваш адрес электронной почты",
  "0b1de22df7": "Пожалуйста, введите адрес электронной почты в правильном формате",
  "61026181ab": "Обязательна подача устава",
  "c3847e604e": "Размер файла превышает 10 МБ, пожалуйста, выберите другой файл",
  "49450f4ec7": "Форма жалобы на совпадение должна быть заполнена",
  "39c3b8fa1d": "Ошибка отправки",
  "3ea44d7963": "Успешная загрузка",
  "5b1aa3c2c4": "Ошибка загрузки",
  "7e7f81eaa3": "Ошибка загрузки, файл больше 10 МБ",
  "2ff1913de1": "Ошибка загрузки, файл должен быть формата .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "Обязательна подача устава",
  "66bda65057": "Размер файла превышает 10 МБ, пожалуйста, выберите другой файл",
  "8f2305a83d": "Форма жалобы на совпадение должна быть заполнена",
  "55ff0c8c6e": "Ошибка отправки",
  "8dad6d950d": "Не удалось получить данные приглашения",
  "a5f0ac3a9a": "Создано успешно",
  "4f1d069770": "Параметры utm доступной страницы приглашения: {0} и имя {1}",
  "f9578cfe6d": "Параметры utm двухступенчатого доступа: {0} и имя {1}",
  "e10d028405": "Двухэтапное руководство pcoffice создано",
  "8e22e4fcc4": "Ссылка на приглашение скопирована",
  "3f327f9f37": "Ошибка копирования, пожалуйста, попробуйте снова",
  "bd1aecb265": "Отмена",
  "b6abf9b19a": "Принимаю",
  "e910d9cc0f": "Отмена",
  "37ab25522d": "Принимаю",
  "196b3eb9cf": "Сканируйте для присоединения",
  "2b81c52e20": "Загрузить изображение",
  "62152fd9f3": "Приглашение по ссылке",
  "e0a3725651": "Извините, ваш текущий браузер не поддерживает загрузку этого QR-кода",
  "8b7883b2c7": "Сканируйте для присоединения",
  "9e9a659ed5": "Загрузить изображение",
  "0d55065a9a": "Приглашение по ссылке",
  "487cf6a106": "Извините, ваш текущий браузер не поддерживает загрузку этого QR-кода",
  "78fd005d1f": "Пожалуйста, введите номер телефона",
  "f909563857": "Использовать этот номер для создания",
  "a26a19f139": "Отменить создание",
  "cc004ac9ee": "Номер телефона",
  "4df8c3c588": "Введите другой номер телефона для создания школы",
  "3151cabb3d": "Введите другой номер телефона для создания компании",
  "56098a71eb": "Нажмите для интеллектуальной проверки и отправки кода подтверждения",
  "e96ec218e4": "Пожалуйста, введите код подтверждения из SMS",
  "ce619a0225": "Код подтверждения отправлен на",
  "0e9863aaeb": "Код введен неправильно, пожалуйста, введите снова",
  "32dc8629e1": "Отправить повторно через секунд",
  "e4eda9add5": "Отправить повторно",
  "b007977564": "Ошибка получения информации об утверждении",
  "d8852ffc9c": "Доступ не для администратора",
  "8a733a2574": "Доступ с мобильного устройства",
  "9e8c152c4f": "Доступ через ПК",
  "2265a55e93": "Согласиться с сервисным соглашением",
  "80dabe5aa3": "Создать инструкцию",
  "7deee8bf5a": "Двухэтапное руководство docsWeb создано",
  "69eb501ecb": "Ваш запрос больше не действителен, доступ невозможен",
  "aa1d9d98ad": "Недостаточно прав, доступ невозможен",
  "fdf2fe129e": "Создать Организацию",
  "7f0ca0df6b": "Скрыть стандартные местоположения",
  "cc6ac2a93c": "Двухэтапное руководство: База установлена",
  "5d6c570bf0": "Двухшаговое руководство перед закрытием",
  "a4eb8a192d": "Команды, которые все создают",
  "4912e16a9d": "Имя компании восстановлено",
  "41c4e87ef2": "Вы можете нажать на ссылку",
  "5e630930c0": "Пересоздать компанию",
  "436a563524": "Если вы уже создали компанию, вы можете следовать",
  "0b6e7cbe7f": "«Как изменить название компании»",
  "cb7bce0775": "Учебник по изменению имени компании",
  "3feadd3040": "Текущая версия слишком старая, использование компании невозможно",
  "3cf23de936": "Ваше программное обеспечение устарело, функции компании недоступны. Пожалуйста, обновите версию программного обеспечения через магазин приложений!",
  "a1c5d5d202": "OK",
  "e50183bd00": "WPS Cloud",
  "e5031ab679": "Безопасность, синхронизация, совместная работа",
  "c870026dfc": "Вход с помощью учетной записи WeChat",
  "e7647cd875": "Вход с помощью учетной записи WPS",
  "07b380074b": "Вход с помощью учетной записи QQ",
  "67921724dd": "Другие способы",
  "254da8a9f5": "Достигнуто максимальное количество вступлений/созданий компаний",
  "3648e4811b": "Войти в Docs",
  "dcd102b346": "Создать настраиваемую команду",
  "8b9b258cbf": "Введите имя команды здесь",
  "19bb6e0ded": "Члены WPS имеют",
  "2d9fe8d938": "права на офисные привилегии, которые помогут вам справляться с проблемами документов в повседневной работе, приходите и попробуйте!",
  "e8c1caa649": "Загрузить из локального",
  "03641083a3": "Переместить из 'Личных документов'",
  "eecd3ab9b5": "В следующий раз",
  "13b447b3a8": "Заменить",
  "3c2fc507fc": "Текущая версия слишком старая, использование компании невозможно",
  "c3615d8134": "Ваше программное обеспечение устарело, функции компании недоступны. Пожалуйста, обновите версию программного обеспечения на официальном сайте!",
  "644a36e05b": "Обновить",
  "d435105f21": "Достигнуто максимальное количество вступлений/созданий компаний",
  "73a286ceb0": "Войти в Docs",
  "c2cec645c0": "Отмена",
  "b5f5b83c0f": "Принимаю",
  "76ec352da5": "Отсканировать код для приглашения коллег",
  "6a509e4487": "Скачать QR-код",
  "940cc4a546": "Невозможно создать компанию",
  "78b2a62ea5": "Войти в существующую компанию или создать новую",
  "3a6da7f6f9": "Текущее количество привязанных компаний к номеру телефона достигло предела (максимум 5 компаний)",
  "93bab52870": "Текущий номер телефона уже привязан к компании, вы можете выбрать вход в существующую компанию:",
  "ce6e0adaf2": "Вы можете выбрать вход в нижеприведенные привязанные компании:",
  "1ce200a92b": "Выделить",
  "bb91ef2999": "Создать новую компанию",
  "024e4a91e5": "Имя компании уже используется",
  "eb089a23a0": "Это имя компании уже зарегистрировано:",
  "7646558701": "Администратор:",
  "1d9c02bd33": "Время регистрации:",
  "919fc7805f": "Советуем вам попробовать найти и связаться с перечисленными выше вашими коллегами.",
  "0ca71a9344": "Вы также можете временно использовать другое имя для создания компании (можно изменить позже), а затем подать апелляцию.",
  "e83a244e90": "Нажмите, чтобы узнать, как обжаловать.",
  "d22bedfb21": "OK",
  "907b78b6e5": "Введите название рабочей группы или команды",
  "7195b0ac1e": "Команды, которые вы, возможно, хотите создать",
  "60ed4f915e": "далее",
  "f5ba8dfb7b": "Пропустить руководство",
  "5c44a3ef68": "Максимум 100 символов",
  "130c53fb20": "Имя не может содержать недопустимые символы и специальные знаки/\\;:*?\"<>|%&",
  "e832d41acc": "Двухшаговое руководство Пропустить",
  "80d9cf7177": "Двухшаговое руководство Обновить",
  "0aebf80435": "Двухшаговое руководство Нажмите label",
  "e74f515977": "Двухэтапное руководство handleSubmit",
  "308d2a53c9": "Двухэтапное руководство createGroup",
  "dda2ed7e18": "Двухшаговое руководство Создание команды не удалось",
  "ded3c35500": "Создание команды не удалось",
  "4f18031bc1": "Двухэтапное руководство createTemplate",
  "091e5cefcc": "Ошибка при создании шаблона из-за двухэтапного процесса",
  "58cf4e00f0": "Код подтверждения",
  "92abbf0385": "Отправить код подтверждения",
  "f0f9976ef9": "Введите номер телефона",
  "a4ce99b1df": "Код подтверждения",
  "39d36e0f9f": "Подтвердить",
  "0fd8a01938": "Отправить",
  "9048a4e842": "Номер телефона",
  "9afa1091eb": "Отправить повторно",
  "58d787001f": "Введите другой номер телефона для создания школы",
  "450905a265": "Введите другой номер телефона для создания предприятия",
  "f7386de3c6": "Выбрать из раскрывающегося списка",
  "27aa05a92c": "Согласиться с условиями обслуживания",
  "80af61cb57": "Вернуться на предыдущую страницу",
  "50149b8d4f": "Имя заявителя",
  "e6756f8749": "Введите ваше имя",
  "3cbd51a2b1": "Имя должно содержать минимум 2 символа, пожалуйста, введите имя из 2-10 символов",
  "4f79b4813f": "Имя поддерживает только китайские символы, цифры, английские буквы и ·",
  "71d3e75983": "Основной номер телефона",
  "afe5149035": "Введите ваш основной номер телефона",
  "1e9270b50f": "Введите ваш основной номер телефона, 11 цифр",
  "ff5dc98dfb": "Пропустить",
  "165be2ab43": "Вернуться на предыдущий шаг",
  "231d8a335a": "Согласиться с условиями обслуживания",
  "1cad008ffc": "Название предприятия {0} уже зарегистрировано, используйте другое",
  "c6e274fcab": "Подтверждение соглашения",
  "b9352504bb": "Закрыть окно соглашения",
  "8409e99ad0": "Открыть окно соглашения",
  "1593c6dd95": "Отправить",
  "4f44a9de22": "Открыть проверку по смс",
  "26b70c68b8": "Пропустите, войдите напрямую в предприятие",
  "a8bebcb302": "Вернуться на предыдущую страницу",
  "c800b4fec5": "Базовая монтировка страницы приглашения",
  "38b396d5b0": "Страница приглашений завершила монтаж в DocsWeb",
  "2eb7f9a9f1": "Ваше обжалование успешно отправлено",
  "2c6f3590fb": "Мы планируем в течение 3 рабочих дней отправить результат на вашу электронную почту",
  "2ea3eff708": ", пожалуйста, проверьте.",
  "53acfba22c": "Пригласите сотрудника прямо сейчас",
  "4e6d282f4f": "Присоединиться к приглашению в предприятие",
  "5f72f4b936": "Пригласите сотрудника прямо сейчас",
  "e5383077ba": "Восстановить название компании",
  "06e3fa2350": "Поиск завершен,",
  "653a263b5e": "Создатель:",
  "769f57269f": "Телефон создателя:",
  "09a224695e": "Пожалуйста, подтвердите, что создатель этой компании является вашим коллегой",
  "3beda6c149": "Если ваш коллега, вы можете с ним связаться",
  "5c74dd10d1": "Измените имя компании или передайте права супер администратора.",
  "da504edb0f": "Если это не ваш коллега, вы можете нажать кнопку ниже, чтобы продолжить восстановление названия компании.",
  "39194faaf1": "Продолжить восстановление имени компании",
  "e22b829e90": "Успешно скопировано",
  "6e1b44752a": "Значение TXT",
  "79881b1d7a": "Пригласить коллегу сейчас",
  "a5344a45f9": "Нажмите в правом верхнем углу и выберите \"Отправить другу\"",
  "a4954a5b08": "Пригласить коллегу сейчас",
  "8e3a1625fb": "Восстановить имя компании",
  "bf8b8c7005": "Загрузить бизнес-лицензию компании",
  "bfd44a66c9": "Нажмите, чтобы выбрать",
  "d503f20925": "Пожалуйста, загрузите сканированную копию или фото бизнес-лицензии компании",
  "cbebe043c5": "Поддерживаются форматы JPG, JPEG, PNG, BMP, PDF, размером не более 10 МБ.",
  "9650b96d7d": "Загрузить информацию для апелляции по совпадению имен",
  "c3b8ae46d3": "Пожалуйста, загрузите сканированную копию или фото информации для апелляции по совпадению имен",
  "9e325a9e09": "Скачать шаблон информационного бланка",
  "a4711aae88": "Подать заявку",
  "3a5cc1441e": "Аутентификация...",
  "0bd7bf8511": "Мы в данный момент не можем проверить ваш домен, возможно, вам придется подождать некоторое время, чтобы ваш хостинг-провайдер обновил вашу информацию. Если через некоторое время не будет результата, пожалуйста, попробуйте проверить снова или измените домен.",
  "fae48d554b": "Проверка домена",
  "5e1779a0ca": "записи проверки, вы можете закрыть эту страницу и вернуться позже, чтобы просмотреть.",
  "ca85f8b836": "Добро пожаловать в корпоративную версию",
  "2570e0f00b": "Сбой входа",
  "40d16a007e": "Ваш личный аккаунт был автоматически привязан",
  "81376b92e4": "{0} способ входа, пожалуйста, войдите снова, чтобы переключиться на корпоративный аккаунт.",
  "ba679ba739": "Понял, зайти в систему",
  "c05f64c6c6": "{0} после автоматического перенаправления для входа",
  "c329ccef3a": "Сбой входа",
  "e370f9afb1": "Ваш личный аккаунт был автоматически привязан",
  "410cf42585": "Способ входа, пожалуйста, войдите снова, чтобы переключиться на аккаунт компании.",
  "062d48aece": "Понял, зайти в систему",
  "95a105d412": "после автоматического перенаправления для входа",
  "2d000d5a6d": "Отправьте ссылку для дележа участникам, которые могут подать заявку на присоединение после открытия",
  "8861b6e90d": "Войти в компанию",
  "25b9f72fda": "Ошибка параметров страницы",
  "1c76123efc": "Не удалось получить ссылку на приглашение",
  "6caba48b76": "Пропустить",
  "f66379c650": "Ошибка параметров страницы",
  "c45021de2a": "Ошибка при создании.",
  "011d470126": "Платформа непрерывно защищает вашу информацию",
  "f1a44d9151": "Платформа получила сертификаты ISO27001 и ISO27701, выданные Международной BSI, а также прошла оценку на соответствие третьему уровню национальной безопасности и квалификации—",
  "255ea5dff7": "Белая книга безопасности",
  "bb55b124f2": "Создать презентацию для компании",
  "61e24974a3": "Создать содержание стратегии привлечения компании",
  "bfdf78febe": "Следующий шаг — дополнить информацию",
  "c4aa2d2d60": "Введите название группы или проекта",
  "b69765ab64": "Команды, которые все создают",
  "9657d9408b": "Заменить",
  "e21da8c16a": "далее",
  "224ef5cc9f": "Пропустить руководство",
  "641f58c8f6": "Текущая компания не поддерживает создание команды членами, пожалуйста, попросите администратора создать.",
  "efea622752": "Скопировать ссылку, пригласить коллег",
  "fd5b40a9fd": "Пригласить вас присоединиться к «{0}» для совместной работы",
  "b04dd2f10a": "Ссылка приглашения скопирована",
  "d1606a1b1a": "Ошибка копирования, пожалуйста, повторите",
  "0d59f3db83": "Введите отдел проекта или команду, например, \"отдел продаж\"",
  "9429513d34": "Руководство не требуется",
  "b54a20b1ff": "Ошибка при создании.",
  "093fa0fb74": "Происходит авторизация...",
  "b383b136f4": "Создание начальной настройки проекта компании",
  "b6b21b388b": "Название компании уже зарегистрировано",
  "285dc68c10": "Это название компании уже зарегистрировано:",
  "1bf685b89d": "Администратор:",
  "7b4297edcc": "Время регистрации:",
  "fa51ea19fc": "Рекомендуем попробовать найти и связаться с вашим коллегой выше.",
  "e3678a996d": "Вы также можете временно использовать другое название для создания компании (можно изменить позже) и подать апелляцию.",
  "5969bc8071": "Хорошо",
  "ba4cf699df": "Восстановить название компании",
  "afecee4eb4": "Ваше имя",
  "a8bdebc614": "Введите ваше имя",
  "5bbeb38a66": "Телефон",
  "b4f7b44b7a": "Введите ваш номер телефона",
  "cac2913686": "Электронная почта",
  "23d3bb3a42": "Введите ваш адрес электронной почты",
  "ea106a393c": "Загрузить бизнес-лицензию компании",
  "f74131d71e": "Нажмите для выбора",
  "53749c51c5": "Пожалуйста, загрузите скан или фотографию бизнес-лицензии компании",
  "c00f2ea171": "Поддерживаются форматы JPG, JPEG, PNG, BMP, PDF, размер не более 10 МБ.",
  "57ec07fa97": "Загрузить форму апелляции о дубликате",
  "8eb0606e94": "Пожалуйста, загрузите скан или фотографию формы апелляции о дубликате",
  "f59e76c0b0": "Скачать шаблон формы информации",
  "030bd26fa4": "Подать заявку",
  "0a602dc727": "Безопасное хранение данных",
  "9138f28acf": "Совместное использование файлов",
  "b3a306cf90": "Легализация",
  "973c53f725": "Рекомендуем изменить название, после регистрации можно подать сертификат органа и обновить название",
  "f886f5e92f": "Рекомендуем изменить название, после регистрации можно подать сертификат компании и обновить название",
  "b8051702a3": "Название содержит чувствительные слова, пожалуйста, измените название или свяжитесь с сотрудником службы поддержки",
  "d73881f7d4": "Название компании защищено",
  "dc7e58e320": "Название компании защищено, перед использованием необходимо проверить информацию о компании. Рекомендуем изменить название компании или зарегистрироваться и использовать название через сертификат компании.",
  "20c3bc070c": "Подтвердить",
  "c4278e5f28": "Недостаточно прав",
  "9217efae21": "У вас нет разрешения на создание, обратитесь к продавцу для решения",
  "52ff08f2ad": "Название учреждения защищено, измените название компании",
  "79386ae280": "Введите 6-значный код",
  "d7b2c5a41b": "Код подтверждения отправлен на",
  "ce2e1c26f7": "(Действительно в течение 10 минут)",
  "59d338903f": "Получение нового кода доступно через {0} секунд",
  "5aadd14136": "Получить код снова",
  "90f5c93432": "Это имя уже зарегистрировано",
  "1677072f4a": "Вы можете добавить больше информации или использовать другое имя для регистрации",
  "3b8459fb1e": "Быстрое заполнение:",
  "6f38edbcb1": "Использовать это имя для регистрации",
  "8406c81e2d": "Филиал",
  "29d323fa85": "Отделение",
  "4f0e806e02": "Финансовый отдел",
  "3f935efb6b": "Согласиться с условиями обслуживания",
  "b42241be05": "Пока нет",
  "99de4b33b7": "Принимаю",
  "7f867e7395": "Создать компанию с другим номером телефона",
  "0d51a8f7a6": "Продолжить создание",
  "8bdaecf2e5": "Введите ваш номер телефона",
  "565ae60c8a": "Введите ваше имя",
  "f76e06d0e7": "Введите ваш номер телефона",
  "7b0fca5255": "Введите код подтверждения",
  "68026d2d25": "Добро пожаловать в корпоративную версию",
  "d25b5541be": "Создать бесплатно",
  "32cfd73733": "Введите название команды, компании или организации",
  "4cf83dc4a0": "Быстрое создание за минуту и эффективная работа с коллегами",
  "d320d37116": "Создать команду/предприятие бесплатно",
  "c54b475dd2": "Пользовательское соглашение",
  "190d54e616": "Компания {0}",
  "8c1b768ac4": "Интеллектуальная проверка не удалась",
  "d74eab0f35": "Имя вашей компании не соответствует требованиям платформы, исправьте и попробуйте снова",
  "0f3d62dd4f": "Ваше имя не соответствует требованиям платформы, исправьте и попробуйте снова",
  "647cf2211b": "Создание с текущим номером телефона не поддерживается, выберите другой номер",
  "b63d96cdae": "Информация не соответствует требованиям платформы, исправьте и попробуйте снова",
  "2dbbe8e43f": "Создание с текущим номером телефона не поддерживается, исправьте и попробуйте снова",
  "b18abc5de6": "Нет привязанного номера телефона",
  "f5233dae6f": "Выберите другой номер для создания",
  "4167c8b88d": "Текущий номер телефона может быть использован ненадлежащим образом, попробуйте другой номер. С вопросами обращайтесь в службу поддержки.",
  "a8a2433c4d": "Сканировать QR-код для добавления в WeChat, обратиться в службу поддержки",
  "444a639c09": "Понятно",
  "69a097057f": "Текущий номер телефона принадлежит <#BB2726>виртуальному оператору<#BB2726>",
  "4370b06fd0": "Текущий номер телефона имеет <#BB2726>аномальную активность<#BB2726>",
  "8c49e1dc4a": "Требуется проверка 'человек или машина'",
  "4b8ba7d8cc": "Новая платформа производительности офисного труда",
  "81be771e17": "🎉Компания успешно создана! Завершите информацию, чтобы получить индивидуальные услуги",
  "461125b057": "Вы можете управлять документами и материалами в WPS Teams. Участники команды могут быстро просматривать и устанавливать права на редактирование/загрузку, чтобы обеспечить безопасность данных",
  "c3eb25029b": "Масштаб вашей компании/команды",
  "049f8401ec": "Менее 5 человек",
  "c81896349e": "6-20 человек",
  "7357daac4e": "21-50 человек",
  "f0e65a0a29": "51-100 человек",
  "b9fac8204a": "101-200 человек",
  "62d73dddaf": "201-500 человек",
  "3bcdaf7160": "501-2000 человек",
  "ab0b2333fe": "Более 2000 человек",
  "4f756eedc8": "Ваша роль",
  "3ba0b502c3": "Генеральный директор",
  "702099cc72": "Финансовые",
  "843b603162": "Закупки",
  "8b414a9b44": "Кадры/Администрация",
  "92486b2908": "Продажи",
  "ac4e7fb063": "У вашей организации есть бюджет/план закупки офисного ПО?",
  "37634c72dc": "В течение шести месяцев",
  "bd94b6deec": "В течение года",
  "713f4aad5c": "Рассматривается",
  "c5ea095a4d": "Нет плана",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Создайте команду и пригласите членов для совместной работы",
  "9d27dc2d90": "Введите название вашей команды или проект, который вы недавно отслеживали",
  "de19c8509a": "Возможно, вам нужно создать:",
  "1a84699223": "Отдел продаж",
  "efab59502b": "Отдел продукции",
  "7e599b3713": "Южный операционный отдел",
  "bf494779c2": "Отдел закупок",
  "f3a60ab34d": "Административный отдел",
  "bbc50c1ac8": "Финансовый отдел Севера",
  "32629e3dac": "Финансовый отдел продукции",
  "5524d354ba": "IT отдел",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>Вы разблокировали права новичка!</span> Пригласите еще 3 человека и получите <span style='color: rgb(206,131,62);'>4T пространства и привилегии WPS AI</span>",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Вы разблокировали лимит 50 человек и возможность загрузки файлов до 4G.</span> Пригласите еще 3 человека, чтобы разблокировать 30 дней WPS AI и 4T дополнительного пространства",
  "136c26d941": "Скопируйте ссылку ниже, чтобы пригласить участников",
  "3de5c12558": "Скопируйте ссылку и пригласите коллег",
  "a5d64b14f3": "Руководство по информации о предприятии",
  "b8f2492701": "Сбор информации о компании",
  "1f9d053dc0": "Создание шаблона команды",
  "0e83c79a88": "Пригласить участников",
  "821fc1906a": "Войти в компанию",
  "463e14ae9c": "Пожалуйста, выберите команду",
  "690f0cdb9e": "Завершить значок",
  "c340522a17": "Предыдущий",
  "f9355c72ef": "Пропустить",
  "bd6c09ebbb": "далее",
  "2a2603cd3f": "Отсканируйте, чтобы отправить приглашение коллегам",
  "411e64907a": "Копировать",
  "b0d988cf23": "Загрузить",
  "e3c0b650ac": "Успешно скопировано",
  "713ac624b4": "Добро пожаловать в WPS 365",
  "b8fff97849": "Недопустимый целевой элемент",
  "02acdcf296": "Ошибка преобразования html2canvas, canvas не создан",
  "a76988c496": "Ошибка преобразования canvas в blob",
  "af89584edf": "api буфера обмена недоступно",
  "f90263bbde": "Ошибка копирования изображения",
  "71b05319da": "Ошибка преобразования html в canvas",
  "38852999fe": "Ошибка сохранения информации",
  "4a4c621d07": "Не удалось создать команду, пожалуйста, повторите попытку позже",
  "d239a23994": "Текущая страница доступна только для корпоративных аккаунтов, пожалуйста, сначала войдите в корпоративный аккаунт.",
  "d93bfb7fb9": "Введите содержимое",
  "42b81a66c4": "Длина от 2 до 100 символов",
  "76d33733db": "Не может содержать такие специальные символы, как / \\ ; : * ? \" < > | % & и другие",
  "dc55d1f62f": "Перейти к опыту",
  "b25233cba0": "Совместная работа над документами + мгновенные сообщения - новый способ эффективной работы",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Начните совместный групповой чат, безопасный и удобный для обмена документами",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Помощник AI Линси - интеллектуальный помощник, созданный для работы",
  "e338385bc9": "Интеллектуальная система для работы с Office, глибокая интеграция AI и офисного ПО для предоставления каждому персонального AI-ассистента",
  "7ae1f3b1c6": "Импорт файлов (папок) завершен, результаты можно посмотреть в \"Мои облачные документы\"",
  "85db2a024a": "Ошибка импорта файлов (папок), попробуйте позже",
  "9ff74c802a": "Скачать версию для чипа Intel",
  "ab44928f02": "Скачать версию для чипа Apple",
  "a08d937c38": "Загрузка файлов (папок), после завершения можно смотреть в \"Мои облачные документы\"",
  "68db1829fa": "Поддерживается только импорт из личного аккаунта, пожалуйста, войдите в личный аккаунт и попробуйте снова.",
  "1185a7c7ab": "До 20 человек",
  "e2bcc252c9": "21-300 человек",
  "3c4842f1ea": "301-1000 человек",
  "1bbee64cfa": "Более 1000 человек",
  "388ff4a035": "Преподаватель",
  "d341b1d794": "Студент",
  "bfb2ee4148": "Другие",
  "f6450c3f31": "Управление проектом",
  "b87fd33a0d": "Годовой план",
  "0dd45a1c14": "Управление эффективностью сотрудников",
  "67fa01cac6": "Маркетинговая активность",
  "6dd82cc031": "Наем сотрудников",
  "a7edaed91d": "Учебные материалы",
  "bf12b7efb0": "Управление учебными планами",
  "c35ae8f358": "Документация продуктов",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\">  Многомерные таблицы WPS, визуальное построение персонализированных бизнес-систем",
  "72286d5519": "👏 Рекомендуемые шаблоны",
  "0bc00ee949": "Управление дефектами требований",
  "e22f3d56f7": "Управление контентным творчеством",
  "dd439de3dd": "Система управления клиентами",
  "fbb2bbf82e": "План подготовки к экзаменам",
  "0645b908bc": "Запрос на ведомость заработной платы",
  "813b3d3d7e": "Управление OKR",
  "918e33d5bd": "Создать одним кликом",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Импортировать часто используемые документы для более удобного использования",
  "c58f28713c": "Импортировать с локального устройства",
  "9d6a0a4370": "Поддерживаемые форматы файлов Office",
  "54c48aee85": "Выбрать файл",
  "c5b593e452": "Импорт из личного аккаунта",
  "4bdcd9d4c5": "Импортировать документы, команды, папки личного аккаунта одним кликом",
  "99b2968905": "Разрешенный импорт",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Скачайте клиент WPS Teams",
  "fe46574227": "Совместная работа с документами + мгновенный обмен сообщениями, новый эффективный способ работы",
  "beefe5a09b": "Загрузка.",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Богатые настройки безопасности, гарантия безопасности данных",
  "b4e70dbeab": "Многолетний опыт WPS в обеспечении безопасности документов, предотвращение утечки важной информации компании",
  "42dc772619": "Файл слишком большой, попробуйте импортировать его позже на главной странице",
  "a052564e47": "Ошибка создания, пожалуйста, повторите попытку позже"
}